module.exports = __webpack_public_path__ + "img/colored-square.4c49693b.svg";